// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RjCUJHi93vgRln {
  display: inline-block;
  text-decoration: underline;
}
.RjCUJHi93vgRln p {
  color: var(--ds-link, #0c66e4);
  font-weight: 700;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"currentCheckItem": `RjCUJHi93vgRln`
};
export default ___CSS_LOADER_EXPORT___;
